<div id="profile_modal_header" class="profile-modal-header">
  <idp-logo-header
    [logoUrl]="profileHeaderContent.logoUrl"
    [altText]="profileHeaderContent.altText"
  ></idp-logo-header>
  <div class="row mx-0">
    <h1 class="profile-modal-header__header-title">
      {{ profileHeaderContent.headerTitle }}
    </h1>
  </div>
  <div
    *ngIf="profileHeaderContent?.headerSubTitle"
    class="profile-modal-header__fields-required-text"
    [ngClass]="{
      'remove-margin-bottom':
        profileHeaderContent.contentBodyHeader !== undefined
    }"
    aria-live="polite"
  >
    {{ profileHeaderContent.headerSubTitle }}
  </div>
  <div
    *ngIf="profileHeaderContent.contentBodyHeader"
    class="profile-modal-header__content-body-header"
  >
    {{ profileHeaderContent.contentBodyHeader }}
  </div>
</div>
